import { Injectable } from "@angular/core";
import { NestApiProvider, FormDataUpload } from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseData, ResponsePaging } from "../../nest-responses";
import { ResponseFindCosCenterDto, ResponseFindOneCostCenterDto, RequestCreateCostCenterDto, RequestUpdateCostCenterDto, RequestDeleteCostCenterByDto, ResponseGetCostCenterDto } from "../dto/cost-center.dto";

@Injectable()
export class CostCenterNestApi {
  private service: string = '';
  private model: string = 'costCenter';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public findCostCenter(payload: { page: number, limit: number }): Observable<ResponsePaging<ResponseFindCosCenterDto>> {
    const method: string = 'POST';
    const func: string = 'findCostCenter';
    const params: any = {};
    const urlParams: any = payload
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseFindCosCenterDto>>(method, url, params, urlParams, body);
  }

  public findOneCostCenter(payload: { costcenterCode: string }): Observable<ResponseData<ResponseFindOneCostCenterDto>> {
    const method: string = 'POST';
    const func: string = 'findOneCostCenter';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseFindOneCostCenterDto>>(method, url, params, urlParams, body);
  }
  
  public getCostCenter(): Observable<ResponseData<ResponseGetCostCenterDto>> {
    const method: string = 'POST';
    const func: string = 'getCostCenter';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetCostCenterDto>>(method, url, params, urlParams, body);
  }

  public createCostCenter(payload: RequestCreateCostCenterDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'createCostCenter';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public updateCostCenter(payload: RequestUpdateCostCenterDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'updateCostCenter';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteCostCenter(payload: { costcenterCode: string }): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteCostCenter';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteCostCenterBy(payload: RequestDeleteCostCenterByDto): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteCostCenterBy';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public downloadTemplate(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, func, params, body);
  }

  public uploadCostCenter(file: File): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadCostCenter';
    const params: FormDataUpload[] = [];
    params.push({name: 'file', value: file});
    const urlParams: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, url, params);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/cost-center.api.ts